import * as React from 'react';
function TableCellImage(props) {
    const { value } = props || {};
    return (<div style={{ width: '60px' }}>
      <img style={{ width: '60px' }} src={value} alt=''/>
    </div>);
}
TableCellImage.displayName = 'TableCellImage';
export { TableCellImage };
